module.exports = __webpack_public_path__ + "static/media/mail.3bdfd2b3.svg";